import { render, staticRenderFns } from "./DisponibilidadHoraria.vue?vue&type=template&id=0ed7c243&scoped=true&"
import script from "./DisponibilidadHoraria.vue?vue&type=script&lang=js&"
export * from "./DisponibilidadHoraria.vue?vue&type=script&lang=js&"
import style0 from "./DisponibilidadHoraria.vue?vue&type=style&index=0&id=0ed7c243&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed7c243",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VContainer,VIcon,VSimpleTable,VSpacer})
